import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagIQ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M25 0C14.25 0 5.087 6.784 1.555 16.304h46.89C44.912 6.784 35.749 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M25 50c10.749 0 19.912-6.784 23.445-16.304H1.555C5.087 43.216 14.25 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M19.022 23.37h-4.82a2.176 2.176 0 0 1 2.102-1.631v-3.26a5.44 5.44 0 0 0-5.434 5.434V26.63h8.151c.3 0 .544.244.544.544v1.087H8.695v3.26h14.131v-4.347a3.809 3.809 0 0 0-3.804-3.805ZM27.174 28.26v-9.782h-3.261v13.044h5.435V28.26h-2.174ZM38.043 28.26v-9.782h-3.26v9.783h-1.087V25h-3.261v6.522h9.782V28.26h-2.174Z"
}));
FlagIQ.displayName = 'FlagIQ';
export default withFlagWrapper(FlagIQ);
//# sourceMappingURL=index.js.map